var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnedriveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6776_6678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.456 10.45C18.2481 9.12484 17.6322 7.89752 16.6941 6.93882C15.7559 5.98012 14.5423 5.33773 13.222 5.10107C11.9017 4.86441 10.5405 5.04525 9.32779 5.61842C8.11509 6.19159 7.11125 7.12857 6.45599 8.29896C5.82033 8.35154 5.20125 8.52882 4.63409 8.82067C4.06694 9.11252 3.56283 9.51322 3.15054 9.99989C2.73824 10.4866 2.42584 11.0497 2.23118 11.6571C2.03651 12.2645 1.96339 12.9043 2.01599 13.54C2.06798 14.1756 2.24465 14.7947 2.53592 15.362C2.82719 15.9294 3.22735 16.4338 3.71357 16.8464C4.19978 17.2591 4.76251 17.5719 5.36964 17.7671C5.97677 17.9623 6.61639 18.036 7.25199 17.984H18.003C18.4974 18.0136 18.9929 17.9455 19.461 17.7837C19.9292 17.6218 20.3608 17.3693 20.7313 17.0405C21.1019 16.7118 21.404 16.3133 21.6205 15.8678C21.837 15.4222 21.9635 14.9384 21.993 14.444C22.0532 13.4454 21.7142 12.4639 21.0507 11.7153C20.3872 10.9666 19.4535 10.5122 18.455 10.452L18.456 10.45Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6776_6678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnedriveIcon);
export default __webpack_public_path__ + "static/media/onedriveIcon.7d84d167a47f97b6faf7f5b4fde46a20.svg";
export { ForwardRef as ReactComponent };